export default __webpack_public_path__ + "static/media/Prestigio-Calacatta-Oro-120x278.2fe97d80.jpg";